import * as React from 'react';
import { SvgIcon } from '@material-ui/core';

const Search = props => {
  return (
    <SvgIcon {...props} width="26" height="26" viewBox="0 0 26 26">
      <g opacity={0.369} transform="translate(0 0.7)">
        <rect fill="none" width="26" height="26" transform="translate(0 -0.7)" />
        <circle
          strokeLinecap="round"
          strokeWidth={2}
          stroke="#000"
          strokeMiterlimit={10}
          fill="none"
          cx="8"
          cy="8"
          r="8"
          transform="translate(3 2.3)"
        />
        <line
          strokeWidth={4}
          stroke="#000"
          strokeMiterlimit={10}
          fill="none"
          x2="6.727"
          y2="6.727"
          transform="translate(16.337 16.291)"
        />
      </g>
    </SvgIcon>
  );
};

export default Search;
